import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../context/SubscriptionContext';
import './SubscriptionWarning.scss';

export default function SubscriptionWarning() {
    const { t } = useTranslation();
    const { data, clockOffset = 0 } = useSubscription();
    const [now, setNow] = useState(() => Date.now() + clockOffset);
    useEffect(() => {
        setNow(Date.now() + clockOffset);
        const interval = setInterval(() => setNow(Date.now() + clockOffset), 1000);
        return () => clearInterval(interval);
    }, [clockOffset]);
    if (!data?.subscription?.endsAt || data.isAdmin) return null;
    const seconds = Math.ceil((Date.parse(data.subscription.endsAt) - now) / 1000);
    if (seconds > 86400 && !data.subscription.cancelled) return null;
    const countdown = `${Math.floor(Math.max(0, seconds) / 3600)}:${String(Math.floor(Math.max(0, seconds) / 60) % 60).padStart(2, '0')}:${String(Math.max(0, seconds) % 60).padStart(2, '0')}`;
    return <div className="subscription-warning" title={t('subscription.expiryWarning', { countdown })}>
        <span>{t(seconds > 0 && !data.subscription.cancelled ? 'subscription.expiryWarning' : 'subscription.expired', { countdown })}</span>
    </div>;
}
